import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesEyeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M17 17c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 14c3.5 0 6.708 3.75 7 5-.292 1.25-3.5 5-7 5s-6.708-3.75-7-5l.036-.124C10.493 17.52 13.61 14 17 14m0 1.8c-1.135 0-2.407.634-3.531 1.598-.54.462-.989.954-1.306 1.375q-.092.125-.158.227.066.102.158.227c.317.421.765.913 1.306 1.375 1.124.964 2.396 1.598 3.531 1.598s2.407-.634 3.531-1.598c.54-.462.989-.954 1.306-1.375q.091-.125.16-.227-.069-.102-.16-.227a9 9 0 0 0-1.306-1.375C19.407 16.434 18.135 15.8 17 15.8"
                fill="currentColor"
            />
            <path
                d="M12 2c9.625 0 11 1.25 11 10h-1.8c0-2.172-.089-3.734-.328-4.889-.233-1.125-.577-1.7-.974-2.06-.416-.379-1.108-.72-2.422-.945C16.154 3.88 14.394 3.8 12 3.8s-4.154.08-5.476.306c-1.314.226-2.006.566-2.422.945-.397.36-.74.935-.974 2.06C2.888 8.266 2.8 9.828 2.8 12s.089 3.734.328 4.889c.233 1.125.577 1.7.974 2.06.416.379 1.108.72 2.422.945q.659.111 1.476.177v1.808C1.972 21.41 1 19.356 1 12 1 3.25 2.375 2 12 2"
                fill="currentColor"
            />
            <path d="M12 12.9H6v-1.8h6z" fill="currentColor" />
            <path d="M18 8.9H6V7.1h12z" fill="currentColor" />
        </g>
    </svg>
));
CardLinesEyeOutlinedSize24Glyph.displayName = 'CardLinesEyeOutlinedSize24Glyph';
